import MagnifyingGlass from '@/components/Icons/MagnifyingGlass';
import React, { useState } from 'react';
import Div from '@/shared/Div';
import CrossIcon from '@/components/Icons/Cross';
import Button from '@/shared/Button';
import Span from '@/shared/Span';
import classNames from 'classnames';

interface SearchBarProps extends React.InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  emptyInput?: boolean;
  onInputChange?: (value: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Search',
  className = '',
  disabled = false,
  onInputChange,
  ...props
}) => {
  const [searchText, setSearchText] = useState('');

  const handleInputChange = (event: any) => {
    const inputValue = event.target.value;
    setSearchText(inputValue);
    if (onInputChange) {
      onInputChange(inputValue);
    }
  };

  const handleCrossIconClick = () => {
    setSearchText('');
    if (onInputChange) {
      onInputChange('');
    }
  };

  return (
    <Div
      className={classNames(
        ' border border-co-bold items-center rounded-cs bg-white flex gap-s3',
        className,
      )}
    >
      <Span className="pl-s3">
        <MagnifyingGlass fillColor={disabled ? '#B3B3B3' : undefined} />
      </Span>
      <input
        value={searchText}
        onChange={handleInputChange}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full h-s9   text-body-base rounded-cs  focus:border-blue-400 focus:outline-none "
        {...props}
      />
      {searchText.length > 0 ? (
        <Button theme="icon" className="pr-s3 " onClick={handleCrossIconClick}>
          <CrossIcon fillColor={disabled ? '#B3B3B3' : undefined} />
        </Button>
      ) : null}
    </Div>
  );
};

export default SearchBar;
